import { ROUTES } from 'ts/Routes';
import * as React from 'react';
import PageConfig from 'ts/services/userflow/PageConfig';
import { ErrorFlow } from 'ts/passwordless-login/components/pages/error/ErrorFlow';
import { AuthCard } from 'ts/components/Card';
import { EnterUsernameForm } from 'ts/passwordless-login/components/pages/enter-username/EnterUsernameForm';
import RegisterClipboard from 'images/register_clipboard.svg';
import { navigateToErrorPageFromForgotPassword } from 'ts/passwordless-login/components/pages/error/ErrorNavigation';
import { History } from 'history';
import { Page } from 'ts/components/Page';
import { USERNAME } from 'ts/constants/UrlParams';
import { CaptchaDisclaimer } from 'ts/login/components/CaptchaDisclaimer';

interface ForgotPasswordEnterUsernamePageProps {
  history: History;
  location: Location;
}

const nextAction = (history: any) => (urlParams: string) => {
  history.push(`${ROUTES.RESET_PASSWORD_ONE_TIME_CODE}?${urlParams}`);
};

const errorAction = (history: any) => (username: string) => {
  const urlParams = new URLSearchParams({
    [USERNAME]: username,
  } as any).toString();
  history.push({
    pathname: ROUTES.FORGOT_USERNAME_FIND_CUSTOMER,
    search: `?${urlParams}`,
  });
};

const pageConfig = {
  errorType: ErrorFlow.resetPassword,
  startRoute: ROUTES.RESET_PASSWORD_ENTER_USERNAME,
  analytics: { pageName: 'forgot-password', taskName: 'forgot-password-new' },
} as PageConfig;

const ForgotPasswordEnterUsernamePage: React.FC<ForgotPasswordEnterUsernamePageProps> = ({
  history,
  location,
}) => {
  return (
    <Page>
      <AuthCard image={RegisterClipboard}>
        <>
          <EnterUsernameForm
            history={history}
            location={location}
            nextAction={nextAction(history)}
            config={pageConfig}
            customErrorAction={errorAction(history)}
            navigateToErrorPage={navigateToErrorPageFromForgotPassword(history)}
            infoText={
              'Please enter the mobile number or email address that’s linked to your account.'
            }
          />
          <CaptchaDisclaimer />
        </>
      </AuthCard>
    </Page>
  );
};

export { ForgotPasswordEnterUsernamePage };
